import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.location_id',
  })

  return {
    variables: {
      location_id,
    },
    pause: !location_id,
  }
}
